module.exports = __webpack_public_path__ + "static/bebauung6-c410bd756507012261000501c41ea0a5.png";